import { render, staticRenderFns } from "./activityDevice.vue?vue&type=template&id=50c20522&scoped=true"
import script from "./activityDevice.vue?vue&type=script&lang=js"
export * from "./activityDevice.vue?vue&type=script&lang=js"
import style0 from "./activityDevice.vue?vue&type=style&index=0&id=50c20522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c20522",
  null
  
)

export default component.exports